Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Figma = void 0;
var _react = _interopRequireDefault(require("react"));
var _generalObserver = require("../general-observer");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Figma = function Figma(_ref) {
  var title = _ref.title,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 450 : _ref$height,
    url = _ref.url;
  var regex = /(file|proto)\/([0-9a-zA-Z]{22,128})(?:\/.*)?$/;
  if (!regex.test(url)) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement(_generalObserver.GeneralObserver, {
    height: height
  }, /*#__PURE__*/_react["default"].createElement("iframe", {
    "data-testid": "figma",
    title: "figma-".concat(title),
    className: "figma-mdx-embed",
    height: height,
    style: {
      width: '100%'
    },
    scrolling: "no",
    src: "https://www.figma.com/embed?embed_host=mdx-embed&url=https://www.figma.com/".concat(url),
    frameBorder: "no",
    allowFullScreen: true
  }));
};
exports.Figma = Figma;